import { translationConnectAi_da } from "./translationConnectAi.da";
import { defineDashboardTranslations } from "./translationTypes";
import { translationConnectAi_en } from "./translationConnectAi.en";
import { translationConnectAi_sv } from "./translationConnectAi.sv";

export const translationConnectAi = defineDashboardTranslations({
  da: translationConnectAi_da,
  en: translationConnectAi_en,
  sv: translationConnectAi_sv,
});
